import React from 'react';
import AgentManagerPageBody from '../components/agentManager/AgentManagerMainPageBody';

function AgenetManagerPage() {
    return <AgentManagerPageBody />;
}

export default AgenetManagerPage;